
export const GET_ACCOUNT = 'GET_ACCOUNT';// 获取用户账户详情
export const OPERATE_ACCOUNT_COIN = 'OPERATE_ACCOUNT_COIN';// 操作浪币
export const GET_ACCOUNT_LOGS = 'GET_ACCOUNT_LOGS';// 获取账户变动日志列表
export const GET_SPEND_LOGS = 'GET_SPEND_LOGS';// 获取充值记录列表

